import React from 'react'
import { Modal, ModalContent } from 'pobble-components/dist/modal'
import injectSheet from 'react-jss'
import QRCode from 'react-qr-code'

const QRCodeComponent = injectSheet({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})(({ classes, link }) => {
  return (
    <div className={classes.container}>
      <QRCode size={300} value={link} />
    </div>
  )
})

export const QRCodeModal = injectSheet({
  content: {
    padding: '80px',
    width: 'auto'
  }
})(({ classes, isOpen, link, requestClose }) => {
  return (
    <Modal closeButton isOpen={isOpen} requestClose={requestClose}>
      <ModalContent className={classes.content}>
        <QRCodeComponent link={link} />
      </ModalContent>
    </Modal>
  )
})
